export default __webpack_public_path__ + "static/media/winner3.9f65db46.jpg";